var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2001 3.20001C2.77575 3.20001 2.36878 3.36858 2.06873 3.66864C1.76867 3.9687 1.6001 4.37567 1.6001 4.80001V5.60001H14.4001V4.80001C14.4001 4.37567 14.2315 3.9687 13.9315 3.66864C13.6314 3.36858 13.2244 3.20001 12.8001 3.20001H3.2001Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 7.20001H1.6001V11.2C1.6001 11.6244 1.76867 12.0313 2.06873 12.3314C2.36878 12.6314 2.77575 12.8 3.2001 12.8H12.8001C13.2244 12.8 13.6314 12.6314 13.9315 12.3314C14.2315 12.0313 14.4001 11.6244 14.4001 11.2V7.20001ZM3.2001 10.4C3.2001 10.1878 3.28438 9.98436 3.43441 9.83433C3.58444 9.6843 3.78792 9.60001 4.0001 9.60001H4.8001C5.01227 9.60001 5.21575 9.6843 5.36578 9.83433C5.51581 9.98436 5.6001 10.1878 5.6001 10.4C5.6001 10.6122 5.51581 10.8157 5.36578 10.9657C5.21575 11.1157 5.01227 11.2 4.8001 11.2H4.0001C3.78792 11.2 3.58444 11.1157 3.43441 10.9657C3.28438 10.8157 3.2001 10.6122 3.2001 10.4ZM7.2001 9.60001C6.98792 9.60001 6.78444 9.6843 6.63441 9.83433C6.48438 9.98436 6.4001 10.1878 6.4001 10.4C6.4001 10.6122 6.48438 10.8157 6.63441 10.9657C6.78444 11.1157 6.98792 11.2 7.2001 11.2H8.0001C8.21227 11.2 8.41575 11.1157 8.56578 10.9657C8.71581 10.8157 8.8001 10.6122 8.8001 10.4C8.8001 10.1878 8.71581 9.98436 8.56578 9.83433C8.41575 9.6843 8.21227 9.60001 8.0001 9.60001H7.2001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.7fccbaa1b643aa9ec48db4a75d5d7b46.svg";
export { ForwardRef as ReactComponent };